import { grey } from "@material-ui/core/colors";

const SELECTED_RAILCAR_BACKGROUND = grey[600];
const SELECTED_RAILCAR_BORDER = grey[100];

export const getSelectedRailcarContainerStyle = (theme) => ({
  border: "1px solid",
  borderColor: SELECTED_RAILCAR_BORDER,
  backgroundColor: SELECTED_RAILCAR_BACKGROUND,
  color: theme.palette.getContrastText(SELECTED_RAILCAR_BACKGROUND),
});

export const getSelectedRailcarSecondaryTextColor = (theme) =>
  theme.palette.getContrastText(SELECTED_RAILCAR_BACKGROUND);

export const getSelectedRailcarIconColor = () => SELECTED_RAILCAR_BORDER;
